import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-m-geofencing-alert-permission",
	templateUrl: "./geofencing-alert.permission.component.html",
	styleUrls: ["./geofencing-alert.permission.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class GeofencingAlertPermissionComponent {}
